"use client";

import { NpsQuestionSet, NpsScore } from "@/types/nps";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import NpsScoreSelector from "./NpsScoreSelector";

type NpsSurveyPromptProps = {
  questions: NpsQuestionSet;
  selectedScore: NpsScore | null;
  disabled?: boolean;
  onClose: () => void;
  onSelectScore: (score: NpsScore) => void;
};

export default function NpsSurveyPrompt({
  questions,
  selectedScore,
  disabled = false,
  onClose,
  onSelectScore,
}: NpsSurveyPromptProps) {
  return (
    <Card className="w-full max-w-xl border-300 shadow-2xl">
      <CardHeader className="flex-row items-start justify-between gap-4 space-y-0">
        <CardTitle className="text-base leading-6">{questions.scoreQuestion}</CardTitle>
        <Button
          type="button"
          variant="ghost"
          size="sm"
          aria-label={questions.close}
          onClick={onClose}
        >
          x
        </Button>
      </CardHeader>
      <CardContent>
        <NpsScoreSelector
          selectedScore={selectedScore}
          disabled={disabled}
          onSelectScore={onSelectScore}
        />
      </CardContent>
    </Card>
  );
}
